export default __webpack_public_path__ + "static/media/burglary.0c61bb93.svg";